import { WalletTransactionStatus } from "../WalletTransactionStatus";
import { schemes, zSchema } from "../../schema-validation";
import { WalletTransactionType } from "../WalletTransactionType";

export const laForgeWalletTransactionSchema = zSchema.object({
  bankAccountID: schemes.uuid().optional(),
  cardID: schemes.uuid().optional(),
  companyID: schemes.companyID(),
  contractorID: schemes.mongoObjectId().optional(),
  date: zSchema.string().optional(),
  description: zSchema.string().optional(),
  employeeID: schemes.mongoObjectId().optional(),
  gross_amount: zSchema.number(),
  last_four: zSchema.string().optional(),
  net_amount: zSchema.number(),
  partner_fee: zSchema.number(),
  recipient_description: zSchema.string().optional(),
  status: zSchema.nativeEnum(WalletTransactionStatus).optional(),
  type: zSchema.nativeEnum(WalletTransactionType),
  walletTransactionID: schemes.uuid(),
  zeal_fee: zSchema.number(),
});

export type TLaForgeWalletTransactionSchema = zSchema.infer<
  typeof laForgeWalletTransactionSchema
>;
